export default {
  dragOrClick: 'Datei hierher ziehen oder klicken, um sie hochzuladen - bis zu {maxSize} | Dateien hierher ziehen oder klicken, um sie hochzuladen - bis zu {maxSize} pro Datei',
  uploadError: 'Die Datei wurde aufgrund eines ungültigen Formats oder einer zu großen Dateigröße nicht hochgeladen: | Einige Dateien wurden aufgrund eines ungültigen Formats oder einer zu großen Dateigröße nicht hochgeladen:',
  dragError: {
    onDragTooManyFiles: 'Es kann nur eine Datei gleichzeitig hochgeladen werden.',
    onDragSomeUnsupportedMimetype: 'Einige der ausgewählten Dateien haben nicht kompatible formate.',
    onDragAllUnsupportedMimetype: 'Keins der Dateiformate wird unterstützt.',
    onDragUnsupportedMimetype: 'Das Dateiformat wird nicht unterstützt.',
  },
};
